export default {"src":"/_next/static/media/cvent.38755210.svg","height":50,"width":251,"blurWidth":0,"blurHeight":0};